import React, { useState } from "react";
import { Button, FloatingLabel, Form } from "react-bootstrap";
import Notiflix from "notiflix";
import PostApiCall from "../Api/PostAPi";
export default function WebsiteForm() {
  const [Loader, setLoader] = useState(false);
  const [Enquiry, setEnquiry] = useState({
    name: "",
    email: "",
    mobile: "",
    EmailRegex:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    NumRegex: /^[0-9]*$/,
  });

  //  **** For Location Route *****
  const route = window.location.pathname;
  let registrationUrl = ""; // Default URL for other routes

  if (route === "/dubai") {
    registrationUrl = "https://propexpo.infairs.co.in/dubai";
  } else if (route === "/abudhabi") {
    registrationUrl = "https://propexpo.infairs.co.in/abudhabi";
  } else if (route === "/singapore") {
    registrationUrl = "https://propexpo.infairs.co.in/singapore";
  } else if (route === "/mahalaxmi-dubai") {
    registrationUrl = "https://propexpo.infairs.co.in/mahalaxmi-dubai";
  } else if (route === "/mahalaxmi-singapore") {
    registrationUrl = "https://propexpo.infairs.co.in/mahalaxmi-singapore";
  }

  const isMobileValid = (mobile) => {
    const regex = /^\+?[0-9\s()]+$/;

    return regex.test(mobile);
  };


  return (
    <div className="row lead-genration-form me-lg-2">
      <h2 className="text-white mb-3">Register to Visit</h2>
      <p className="landin-form-text">Let's meet in person and discuss.</p>
      <div className="col-12">
        <FloatingLabel
          controlId="floatingInput"
          label="Name *"
          className="mb-3">
          <Form.Control
            type="text"
            placeholder="Enter name"
            name="name"
            value={Enquiry.name}
            onChange={(e) =>
              setEnquiry({ ...Enquiry, [e.target.name]: e.target.value })
            }
          />
        </FloatingLabel>
      </div>
      <div className="col-12">
        <FloatingLabel
          controlId="floatingInput"
          label="Email *"
          className="mb-3">
          <Form.Control
            type="email"
            placeholder="Enter email"
            name="email"
            value={Enquiry.email}
            onChange={(e) =>
              setEnquiry({ ...Enquiry, [e.target.name]: e.target.value })
            }
          />
        </FloatingLabel>
      </div>
      <div className="col-12">
        <FloatingLabel
          controlId="floatingInput"
          label="Mobile No. *"
          className="mb-3">
          <Form.Control
            type="text"
            placeholder="Enter moblie no."

            name="mobile"
            value={Enquiry.mobile}
            onChange={(e) => {
              setEnquiry({
                ...Enquiry,
                [e.target.name]: e.target.value,
              });
            }}
          />
        </FloatingLabel>
      </div>

      <div>
        <Button
          variant="light"
          type="submit"
          className="fw-bold"
          onClick={() => {
            if (Enquiry.name != "") {
              if (Enquiry.email != "") {
                if (Enquiry.EmailRegex.test(Enquiry.email)) {
                  if (Enquiry.mobile != "") {
                    if (isMobileValid(Enquiry.mobile) == true) {
                      setLoader(true);
                      PostApiCall.postRequest(
                        {
                          name: Enquiry.name,
                          mobile: Enquiry.mobile,
                          email: Enquiry.email,
                          registrationUrl: registrationUrl,
                        },
                        "RunwalShowEnquiry"
                      ).then((results2) =>
                        results2.json().then((obj2) => {
                          if (
                            results2.status == 200 ||
                            results2.status == 201
                          ) {
                            setLoader(false);
                            Notiflix.Notify.success(
                              "Thank you for registering."
                            );
                            setTimeout(() => {
                              window.location.reload();
                            }, 3000);
                          }
                        })
                      );
                    } else {
                      Notiflix.Notify.failure(
                        "Please enter valid mobile number"
                      );
                    }
                  } else {
                    Notiflix.Notify.failure("Please enter mobile number");
                  }
                } else {
                  Notiflix.Notify.failure("Please enter valid email ");
                }
              } else {
                Notiflix.Notify.failure("Please enter email");
              }
            } else {
              Notiflix.Notify.failure("Please enter name");
            }
          }}>
          {Loader == true ? (
            <div className="d-flex justify-content-center">
              <div
                className="spinner-border"
                role="status"
                style={{ width: "1.4rem", height: "1.4rem" }}>
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            "Submit"
          )}
        </Button>
      </div>
    </div>
  );
}
